export const isOperandioSupportUser = (email) => {
  return email?.endsWith("@operandio.com")
}
